// extracted by mini-css-extract-plugin
export default {"aboutText":"HomeScreen_aboutText__VlVXH","link":"HomeScreen_link__G-t5V","titleImg":"HomeScreen_titleImg__yCqD1"};